import React from 'react';
import { Dialog } from '@mui/material';
import ExternalAddForm from './ExternalAddForm';

const ToggleModalExternalsAdd = ({
  open,
  toggle,
  getData,
  setSnackBarMessage,
  setSnackbarSeverity,
  setSnackBarOpen
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="sm"
      scroll="paper"
      onClose={toggle}
    >
      <ExternalAddForm
        getData={getData}
        setSnackBarMessage={setSnackBarMessage}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarOpen={setSnackBarOpen}
        toggle={toggle}
      />
    </Dialog>
  );
};

export default ToggleModalExternalsAdd;
